import {
  hoursWatchedText,
  peakCCVText,
  avgCCVText,
  airtimeText,
  influencerFollowersTipsText,
  influencerAllPublicationsTipsText,
  influencerStreamingInfluencerTipsText,
  communityInfluencerAirtimeTipsText,
  influencerAllEngagementTipsText,
  communityGrowthOfFollowersTipsText,
  communityPeakCCVTipsText,
  communityInfluencerAvgCCVTipsText,
  communityStreamingPeakCCVMaxText,
  communityTableAllEngagementTipsText,
  communityVideoEngagementTipsText,
  communityTablePostEngagementTipsText,
  communityTableVideoEngagementTipsText,
  influencerAllViewsTipsText,
  influencerTop50FollowersTipsText,
  influencerTotalSessionsTipsText,
  influencerVideoInfluencerTipsText,
  influencerPostInfluencerTipsText,
  influencerSumInfluencerTipsText,
  influencerVideoViewsTipsText,
  influencerPostPublicationsTipsText,
  influencerPostEngagementTipsText,
  influencerViewPerVideoTipsText,
  influencerViewPerPostTipsText,
  influencerViewPerSumTipsText,
  influencerBrandAffinityTipsText,
  influencerGamesCoveredTipsText,
  influencerGrowthOfFollowersTipsText,
  influencerTotalPublicationsTipsText,
  influencerBrandRelatedPublicationsTipsText,
  influencerBrandRelatedAvgViewsTipsText,
  influencerAvgEngagementRateTipsText,
  influencerAvgViewTipsText,
  influencerCoreTagsTipsText,
  influencerMultiGamerTagsTipsText,
  influencerMonthlyReturningTagsTipsText,
  influencerQuarterlyReturningTagsTipsText,
  influencerViewsLossRateTipsText,
  brandCreatorAllLikesTipsText,
  brandCreatorAllViewsTipsText,
  brandCreatorAllCommentsTipsText,
} from '@/pages/opinion/components/BubbleCommon';
import { arrayToObj, arrayToSimpleObj } from '@/pages/opinion/utils';
import { avgValueFormat, reviewsFormat } from '@/pages/opinion/utils/value';
import { renderHelperViewImpairmentRate } from '@op/components/DownloadCommon/download-page/render-helper';
interface TagOption {
  text: string;
  value: string;
  color?: string;
  background?: string;
}

export const metricsOptions = [
  { text: 'Hours Watched', value: 'hoursWatched' },
  { text: 'Peak CCV', value: 'peakCCV' },
  { text: 'Avg CCV', value: 'avgCCV' },
  { text: 'Airtime', value: 'airtime' },
];

const sortItemMap: any = {
  peak_ccv: 'peakCCV',
  avg_ccv: 'avgCCV',
  hours_watched: 'hoursWatched',
  followers: 'follower_number',
  views: 'tweets_view',
  shares: 'tweets_retweet',
  mentions: 'tweets_reply',
  likes: 'tweets_like',
};

export function dealwithSortItem(params: any, isStream = false) {
  const { sort_item } = params;
  if (isStream && sort_item === 'followers') {
    return params;
  }
  const sortItem = sortItemMap[sort_item] || sort_item;
  return {
    ...params,
    sort_item: sortItem,
  };
}

const BASE_TAG_OPTIONS: TagOption[] = [
  // {
  //   text: 'New',
  //   value: 'new',
  //   color: '#5086F3',
  //   background: 'rgba(80, 134, 243, 0.12)',
  // },
  {
    text: 'Active',
    value: 'active',
    color: '#45A1CC',
    background: 'rgba(94, 200, 241, 0.12)',
  },
  {
    text: 'Potential',
    value: 'potential',
    color: '#6E7794',
    background: 'rgba(110, 119, 148, 0.12)',
  },
  {
    text: 'No Tags',
    value: 'not-tag',
  },
  {
    text: 'Core',
    value: 'core',
    color: '#F19E55',
    background: '#FDF1E7',
  },
  {
    text: 'Multi-Gamer',
    value: 'multi-gamer',
    color: '#3780DF',
    background: 'rgba(208, 228, 254, 1)',
  },
];

const RETURNING_TAG: TagOption[] = [
  {
    text: 'Monthly Returning',
    value: 'monthly_returning',
    color: '#AD53D4',
    background: 'rgba(173, 83, 212, 0.12)',
  },
  {
    text: 'Quarterly Returning',
    value: 'quarterly_returning',
    color: '#7F6FF1',
    background: 'rgba(127, 111, 241, 0.12)',
  },
];

const PARTNERED_TAG: TagOption = {
  text: 'Partnered',
  value: 'partnered',
  color: '#29B569',
  background: 'rgba(119, 224, 151, 0.2)',
};

const CREATOR_HUB_TAG: TagOption = {
  text: 'Creator Hub Incentive',
  value: 'creatorhub',
  color: '#7F6FF1',
  background: 'rgba(127, 111, 241, 0.12)',
};

const PUBGM_SEA_TAGS_LABEL = [
  'Next Star',
  'PUBGM Partnered',
  'Paid',
  'Give UC',
  'PUBGM Esports Player',
  'PUBGM Active',
  'PUBGM Potential',
  'Mass KOL',
  'General Game KOL',
  'Competitor KOL-MLBB',
  'Competitor KOL-FF',
  'Competitor KOL-CODM',
  'Competitor KOL-AB',
  'Competitor KOL-Roblox',
  '#PUBGMID2025Creator',
  '#PUBGMIDJadiCreator2025',
  '#PUBGMOBILEMMM2025Creator',
  '#PUBGMTH2025Creator',
  'BR',
  'WoW',
  'MR',
];

export const PUBGM_TAGS: TagOption[] = PUBGM_SEA_TAGS_LABEL.map(item => ({
  text: item,
  value: item,
  color: '#6A6D7E',
  background: '#EBECF1',
}));

export const THIRD_PARTY_TAGS: TagOption[] = [
  {
    text: 'Third Party',
    value: 'third-party',
    color: '#7F6FF1',
    background: 'rgba(127, 111, 241, 0.12)',
  },
];

export const tagOptions = ({ hasKolTagsFilter = false, gameId = '' }) => {
  let options = [...BASE_TAG_OPTIONS];
  const isPUBGM = gameId === 'ufc454d9b1af70b40588e2a6fa4da4a8b';
  if (isPUBGM) {
    options = [...options, ...PUBGM_TAGS];
  }
  if (gameId === 'u10000000022') {
    options = [...options, ...THIRD_PARTY_TAGS];
  }
  if (!hasKolTagsFilter) {
    options = [PARTNERED_TAG, ...options];
  }
  return options;
};

export const tagsOptionsMap = arrayToObj(
  [
    ...BASE_TAG_OPTIONS,
    PARTNERED_TAG,
    CREATOR_HUB_TAG,
    ...RETURNING_TAG,
    ...PUBGM_TAGS,
    ...THIRD_PARTY_TAGS,
  ],
  'value',
);

export const getChartMetricsOptions = (metric: string) => {
  const metricsOptionsMap: {
    [key: string]: Array<{ text: string; value: string }>;
  } = {
    sum: [
      // { text: 'Followers', value: 'followers' },
      // { text: 'Growth of Followers', value: 'growth_of_followers' },
      { text: 'All Publications', value: 'posts' },
      { text: 'All Views', value: 'views' },
      { text: 'All Engagement', value: 'engagements' },
      { text: 'View Per Publication', value: 'view_per_posts' },
    ],
    video: [
      { text: 'Video Publications', value: 'posts' },
      { text: 'Video Views', value: 'views' },
      { text: 'Video Engagement', value: 'engagements' },
      { text: 'View Per Video', value: 'view_per_posts' },
    ],
    post: [
      { text: 'Post Publications', value: 'posts' },
      { text: 'Post Views', value: 'views' },
      { text: 'Post Engagements', value: 'engagements' },
      { text: 'View Per Post', value: 'view_per_posts' },
    ],
    stream: [
      // { text: 'Followers', value: 'followers' },
      // { text: 'Growth of Followers', value: 'growth_of_followers' },
      { text: 'Total Sessions', value: 'posts' },
      { text: 'Peak CCV', value: 'peak_ccv' },
      { text: 'Avg CCV', value: 'avg_ccv' },
      { text: 'Hours Watched', value: 'hours_watched' },
      { text: 'Airtime', value: 'airtime' },
    ],
  };

  return metricsOptionsMap[metric];
};

export const streamMetricsOptionsMap = arrayToSimpleObj(metricsOptions);

export const commonMetricsOptions = [
  { text: 'Views', value: 'views' },
  { text: 'Engagement', value: 'engagement' },
];

export const channelList = ['twitch', 'youtube', 'facebook'];

export const metricsMap = arrayToSimpleObj(metricsOptions);

export const channelNameMap: any = {
  ytg: 'Youtube',
  twitch: 'Twitch',
  facebook: 'Facebook',
};

export const tipsMap: any = {
  hoursWatched: hoursWatchedText,
  peakCCV: peakCCVText,
  avgCCV: avgCCVText,
  airtime: airtimeText,
};

export const titleMap: any = {
  hoursWatched: 'Sum Hours Watched',
  peakCCV: 'Max CCV',
  avgCCV: 'Avg CCV',
  airtime: 'Sum Airtime',
};

export const countMap: any = {
  hoursWatched: 'total',
  peakCCV: 'peakCCvMax',
  avgCCV: 'avg',
  airtime: 'total',
};

export const timelineTypeOptions = [
  { text: 'Mentions', value: 'mentions' },
  { text: 'Negative', value: 'negative' },
  { text: 'Non Negative%', value: 'non-negative' },
  { text: 'Sentiment', value: 'sentiment' },
];

export const timeLineTypeMap = arrayToSimpleObj(timelineTypeOptions);

export const formatValueMap: any = {
  followers: (value: number) => reviewsFormat(value),
  posts: (value: number) => reviewsFormat(value),
  engagements: (value: number) => reviewsFormat(value),
  views: (value: number) => reviewsFormat(value),
  view_per_posts: (value: number) => reviewsFormat(value),
  peak_ccv: (value: number) => reviewsFormat(value),
  avg_ccv: (value: number) => avgValueFormat(value),
  hours_watched: (value: number) => avgValueFormat(value),
  airtime: (value: number) => avgValueFormat(value),
  growth_of_followers: (value: number) => reviewsFormat(value),
};

export const keyMetricsMap: any = {
  sum: {
    influencers: {
      title: 'Influencers-1',
      tipsMap: influencerSumInfluencerTipsText,
      sort: 1,
    },
    posts: {
      title: 'All Publications',
      tipsMap: influencerAllPublicationsTipsText,
      sort: 2,
    },
    all_views: {
      title: 'All Views',
      tipsMap: influencerAllViewsTipsText,
      sort: 3,
    },
    all_engagement: {
      title: 'All Engagement',
      tipsMap: influencerAllEngagementTipsText,
      sort: 4,
    },
    follower: {
      title: 'Followers (Top 50 AVG)',
      tipsMap: influencerTop50FollowersTipsText,
      sort: 5,
      key: 'avg_follower',
    },
  },
  video: {
    influencers: {
      title: 'Video Influencers',
      tipsMap: influencerVideoInfluencerTipsText,
      sort: 1,
    },
    posts: {
      title: 'Video Publications',
      tipsMap: influencerVideoViewsTipsText,
      sort: 2,
    },
    all_views: {
      title: 'Video Views',
      tipsMap: influencerVideoViewsTipsText,
      sort: 3,
    },
    all_engagement: {
      title: 'Video Engagement',
      tipsMap: communityVideoEngagementTipsText,
      sort: 4,
    },
    follower: {
      title: 'Followers (Top 50 AVG)',
      tipsMap: influencerTop50FollowersTipsText,
      sort: 5,
      key: 'avg_follower',
    },
  },
  stream: {
    influencers: {
      title: 'Streaming Influencers',
      tipsMap: influencerStreamingInfluencerTipsText,
      sort: 1,
    },
    posts: {
      title: 'Total Sessions',
      tipsMap: influencerTotalSessionsTipsText,
      sort: 2,
    },
    // peakCCV: {
    //   title: 'Peak CCV',
    //   tipsMap: communityStreamingPeakCCVMaxText,
    //   sort: 3,
    // },
    avgCCV: {
      title: 'Avg CCV',
      tipsMap: communityInfluencerAvgCCVTipsText,
      sort: 4,
    },
    hoursWatched: {
      title: 'Hours Watched',
      tipsMap: hoursWatchedText,
      sort: 5,
    },
    follower: {
      title: 'Followers (Top 50 AVG)',
      tipsMap: influencerTop50FollowersTipsText,
      sort: 6,
      key: 'avg_follower',
    },
  },
  post: {
    influencers: {
      title: 'Post Influencers',
      tipsMap: influencerPostInfluencerTipsText,
      sort: 1,
    },
    posts: {
      title: 'Post Publications',
      tipsMap: influencerPostPublicationsTipsText,
      sort: 2,
    },
    all_views: {
      title: 'Post Views',
      tipsMap: influencerPostPublicationsTipsText,
      sort: 3,
    },
    all_engagement: {
      title: 'Post Engagements',
      tipsMap: influencerPostEngagementTipsText,
      sort: 4,
    },
    follower: {
      title: 'Followers (Top 50 AVG)',
      tipsMap: influencerTop50FollowersTipsText,
      sort: 5,
      key: 'avg_follower',
    },
  },
};

// 表格数据key，与后端接口对应
export const tableDataKeys = [
  'mentions',
  // 'engagements',
  'followers',
  'likes',
  // 'publications',
  'shares',
  // 'views',
  'view_per_posts',
];
export const streamingTableDataKeys = [
  'airtime',
  'avgCCV',
  'hoursWatched',
  'peakCCV',
];

export const genreCreatorListDataKeys = [
  'affinity',
  'avg_engagements',
  'avg_game_engagements',
  'avg_game_views',
  'avg_views',
  'followers',
  'game_count',
  'author_total',
  'game_total',
  'avg_engagements_rate',
  'view_impairment_rate',
];

// 表格列，key对应接口
export const tableColumnsMap: any = {
  sum: [
    {
      key: 'followers',
      header: 'Followers',
      tips: influencerFollowersTipsText,
    },
    {
      key: 'followers_grow',
      header: 'Growth of Followers',
      width: 205,
      tips: communityGrowthOfFollowersTipsText,
    },
    {
      key: 'posts',
      header: 'All Publications',
      tips: influencerAllPublicationsTipsText,
      showChart: true,
      width: 276,
      align: 'right',
      showRelatedGame: true,
    },
    {
      key: 'views',
      header: 'All Views',
      tips: brandCreatorAllViewsTipsText,
      showChart: true,
      width: 276,
      align: 'right',
      showRelatedGame: true,
    },
    {
      key: 'engagements',
      header: 'All Engagement',
      tips: communityTableAllEngagementTipsText,
      showChart: true,
      align: 'right',
      width: 276,
      showRelatedGame: true,
    },
    {
      key: 'likes',
      header: 'All Likes',
      tips: brandCreatorAllLikesTipsText,
      width: 276,
      align: 'right',
      showChart: true,
      showRelatedGame: true,
    },
    {
      key: 'mentions',
      width: 276,
      header: 'All Comments',
      tips: brandCreatorAllCommentsTipsText,
      align: 'right',
      showChart: true,
      showRelatedGame: true,
    },
    {
      key: 'view_per_posts',
      header: 'View Per Publication',
      width: 230,
      tips: influencerViewPerSumTipsText,
    },
  ],
  video: [
    {
      key: 'followers',
      header: 'Followers',
      tips: influencerFollowersTipsText,
    },
    {
      key: 'followers_grow',
      header: 'Growth of Followers',
      tips: communityGrowthOfFollowersTipsText,
    },
    {
      key: 'posts',
      header: 'Video Publications',
      tips: influencerAllPublicationsTipsText,
      showChart: true,
      width: 276,
      align: 'right',
      showRelatedGame: true,
    },
    {
      key: 'views',
      header: 'Video Views',
      showChart: true,
      width: 276,
      align: 'right',
      showRelatedGame: true,
    },
    {
      key: 'engagements',
      header: 'Video Engagements',
      tips: communityTableVideoEngagementTipsText,
      showChart: true,
      align: 'right',
      width: 276,
      showRelatedGame: true,
    },
    {
      key: 'likes',
      header: 'Video Likes',
      width: 276,
      align: 'right',
      showChart: true,
      showRelatedGame: true,
    },
    {
      key: 'mentions',
      header: 'Video Comments',
      width: 276,
      align: 'right',
      showChart: true,
      showRelatedGame: true,
    },
    { key: 'shares', header: 'Video Share', showRelatedGame: true, width: 210 },
    {
      key: 'view_per_posts',
      header: 'View Per Video',
      tips: influencerViewPerVideoTipsText,
    },
  ],
  post: [
    {
      key: 'followers',
      header: 'Followers',
      tips: influencerFollowersTipsText,
    },
    {
      key: 'followers_grow',
      header: 'Growth of Followers',
      tips: communityGrowthOfFollowersTipsText,
    },
    {
      key: 'posts',
      header: 'Post Publications',
      width: 276,
      tips: influencerAllPublicationsTipsText,
      showChart: true,
      align: 'right',
      showRelatedGame: true,
    },
    {
      key: 'views',
      header: 'Post Views',
      showChart: true,
      width: 276,
      align: 'right',
      showRelatedGame: true,
    },
    {
      key: 'engagements',
      header: 'Post Engagements',
      tips: communityTablePostEngagementTipsText,
      showChart: true,
      width: 276,
      align: 'right',
      showRelatedGame: true,
    },
    {
      key: 'likes',
      header: 'Post Likes',
      width: 276,
      align: 'right',
      showChart: true,
      showRelatedGame: true,
    },
    {
      key: 'mentions',
      header: 'Post Comments',
      width: 276,
      align: 'right',
      showChart: true,
      showRelatedGame: true,
    },
    { key: 'shares', header: 'Post Share', showRelatedGame: true, width: 210 },
    {
      key: 'view_per_posts',
      header: 'View Per Post',
      tips: influencerViewPerPostTipsText,
    },
  ],
  stream: [
    {
      key: 'posts',
      header: 'Total Sessions',
      tips: influencerTotalSessionsTipsText,
    },
    {
      key: 'followers',
      header: 'Followers',
      tips: influencerFollowersTipsText,
    },
    {
      key: 'followers_grow',
      header: 'Growth of Followers',
      tips: communityGrowthOfFollowersTipsText,
    },
    {
      key: 'peak_ccv',
      header: 'Peak CCV',
      tips: communityPeakCCVTipsText,
      numFmt: '#,##0.00',
    },
    { key: 'avg_ccv', header: 'Avg CCV', tips: avgCCVText, numFmt: '#,##0.00' },
    {
      key: 'hours_watched',
      header: 'Hours Watched',
      tips: hoursWatchedText,
      numFmt: '#,##0.00',
    },
    {
      key: 'airtime',
      header: 'Airtime',
      tips: communityInfluencerAirtimeTipsText,
      numFmt: '#,##0.00',
    },
  ],
};

export const maxValueKeyMap: { [key: string]: string } = {
  engagements: 'engagement',
  views: 'view',
  posts: 'post',
  likes: 'likes',
  mentions: 'mentions',
};

// 表格列，key对应接口
export const influenceListColumnsMap: any = (gameInfo: any) => {
  const viewsLossRateColumn = [
    {
      key: 'view_impairment_rate',
      header: 'Brand-Related Views Loss Rate',
      tips: influencerViewsLossRateTipsText,
      isPercentage: true,
      numFmt: '0.00%',
      width: 310,
      renderHelper: [renderHelperViewImpairmentRate],
    },
  ];

  return [
    {
      key: 'affinity',
      header: 'Brand Affinity',
      tips: influencerBrandAffinityTipsText,
      isPercentage: true,
      numFmt: '0.00%',
      width: 175,
    },
    {
      key: 'tweets_games_details',
      header: 'Games Covered',
      showGame: true,
      haveSort: false,
      align: 'left',
      width: 215,
      tips: influencerGamesCoveredTipsText,
    },
    {
      key: 'followers',
      header: 'Followers',
      showRatio: false,
      width: 132,
    },
    {
      key: 'followers_grow',
      header: 'Growth of Followers',
      width: 205,
      showRatio: false,
      tips: influencerGrowthOfFollowersTipsText,
    },
    {
      key: 'author_total',
      header: 'Total Publications',
      tips: influencerTotalPublicationsTipsText,
      width: 205,
    },
    {
      key: 'avg_views',
      header: 'Avg Views',
      align: 'right',
      width: 150,
      showRatio: false,
      tips: influencerAvgViewTipsText,
      numFmt: '#,##0.00',
    },
    {
      key: 'avg_engagements_rate',
      header: 'Avg Engagement Rate',
      width: 234,
      align: 'right',
      isPercentage: true,
      tips: influencerAvgEngagementRateTipsText,
      numFmt: '0.00%',
    },
    {
      key: 'avg_game_views',
      header: 'Brand-Related Avg Views',
      width: 260,
      align: 'right',
      tips: influencerBrandRelatedAvgViewsTipsText,
      numFmt: '#,##0.00',
    },
    ...(gameInfo?.edition_unified_id === 'e11000000311'
      ? viewsLossRateColumn
      : []),
    {
      key: 'game_total',
      header: 'Brand-Related Publications',
      width: 274,
      align: 'right',
      tips: influencerBrandRelatedPublicationsTipsText,
    },
  ];
};

export const genreCreatorListTagsList = [
  {
    text: 'Partnered',
    bgColor: 'rgba(119, 224, 151, 0.2)',
    color: '#29b569',
    key: 'partnered',
  },
  {
    text: 'Core: Brand-Related',
    bgColor: '#172F80',
    color: '#fff',
    key: 'brand-related',
  },
  {
    text: 'Subcore: Competitor-Related',
    bgColor: '#3865CC',
    color: '#fff',
    key: 'competitor-related',
  },
  {
    text: 'Genre: Genre-Related',
    bgColor: '#7CADFC',
    color: '#fff',
    key: 'genre-related',
  },
  {
    text: 'Variety',
    bgColor: '#D0E4FE',
    color: '#262832',
    key: 'variety',
  },
  {
    text: 'Multi-Gamer',
    bgColor: 'rgba(208, 228, 254, 1)',
    color: '#3780DF',
    key: 'multi-gamer',
  },
  {
    text: 'Core',
    bgColor: '#FDF1E7',
    color: '#F19E55',
    key: 'core',
  },
  { text: 'Others', bgColor: '#D7F0FF', color: '#262832', key: 'others' },
];

export const filterInfluencerTagsList = [
  'brand-related',
  'competitor-related',
  'genre-related',
  'variety',
  'others',
];

export const genrePUBGMTagsList = PUBGM_TAGS.map(item => ({
  ...item,
  bgColor: item.background,
  key: item.value,
}));

export const GENRE_THIRD_PARTY_TAGS = THIRD_PARTY_TAGS.map(item => ({
  ...item,
  bgColor: item.background,
  key: item.value,
}));

export const genreCreatorListTagsColorMap = arrayToObj(
  [
    ...genreCreatorListTagsList,
    ...genrePUBGMTagsList,
    ...GENRE_THIRD_PARTY_TAGS,
  ],
  'key',
);

/**
 * TODO: 其他系统使用
 * influencer卡片平台排序映射
 */
export const influencerSortMap = {
  common: 1,
  nano: 2,
  micro: 3,
  'mid-tier': 4,
  macro: 5,
  mega: 6,
};

/**
 * TODO: 其他系统使用
 * influencer卡片平台颜色映射
 */
export const influencerColorMap = {
  common: '#CBE2FE',
  nano: '#A6C9FD',
  micro: '#78A9FC',
  'mid-tier': '#4F86F3',
  macro: '#3762C8',
  mega: '#2648A6',
};

export const influencerCoreTagsTipsMap: any = {
  core: influencerCoreTagsTipsText,
  'multi-gamer': influencerMultiGamerTagsTipsText,
  monthly_returning: influencerMonthlyReturningTagsTipsText,
  quarterly_returning: influencerQuarterlyReturningTagsTipsText,
};
